
import { Package, TrendingUp, FileClock, Archive } from "lucide-react";
import { StatCard } from "./StatCard";

interface PackageStatsProps {
  stats: {
    total: number;
    active: number;
    draft: number;
    expired: number;
  };
}

export const PackageStats = ({ stats }: PackageStatsProps) => (
  <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
    <StatCard title="إجمالي العروض" value={stats.total} icon={Package} />
    <StatCard title="العروض النشطة" value={stats.active} icon={TrendingUp} />
    <StatCard title="المسودات" value={stats.draft} icon={FileClock} />
    <StatCard title="العروض المنتهية" value={stats.expired} icon={Archive} />
  </div>
);
